import {getParamsFromUrl} from "@/lib/util";
import {DEFAULT_INDEX} from "@/router";

export default function (bus) {
  /**
   * 递归返回到指定页面
   */
  bus.$on('diyback', (url) => {
    const hashchange = (e) => {
      Log('newV------------------', e);
      const newURL = e.newURL;
      if (!newURL) return;
      const {hash} = getParamsFromUrl(newURL);
      const path = getPathFromHash(hash);
      if (!path) return;
      if (path === url || hash === DEFAULT_INDEX) {
        window.removeEventListener('hashchange', hashchange);
      } else
        history.back();
    }
    window.addEventListener('hashchange', hashchange);
    history.back();
  })
}

/**
 * 从hash字符串中提取path
 */
function getPathFromHash(hash) {
  return hash.split('?')[0];
}



// WEBPACK FOOTER //
// ./src/lib/diyBack.js